import { render, staticRenderFns } from "./sem-dot.vue?vue&type=template&id=1abbe671&scoped=true"
import script from "./sem-dot.vue?vue&type=script&lang=js"
export * from "./sem-dot.vue?vue&type=script&lang=js"
import style0 from "./sem-dot.vue?vue&type=style&index=0&id=1abbe671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abbe671",
  null
  
)

export default component.exports